import { coreLeftView } from '@/components/core-left-view';
import { Stack } from 'expo-router';

export default function FeedbackLayout() {
  return (
    <Stack>
      <Stack.Screen
        name="index"
        options={{
          headerShown: true,
          title: 'Feedback',
          headerLargeTitle: true,
          headerStyle: { backgroundColor: '#0f1313' },
          headerLeft: coreLeftView
        }}
      />
    </Stack>
  );
}
